import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useUser } from '../context/UserContext';
import './AdBlockDetector.css';

export default function AdBlockDetector() {
  const { user } = useUser();
  const [adBlockDetected, setAdBlockDetected] = useState(false);

  useEffect(() => {
    // Les premium sont exemptés
    if (user?.premium) return;

    const detectAdBlock = async () => {
      try {
        // Méthode 1 : créer un élément qui ressemble à une pub
        const bait = document.createElement('div');
        bait.className = 'ad_unit ad-unit textAd text_ad text-ad pub_300x250 pub_300x250m pub_728x90 ads adsbox';
        bait.style.cssText = 'position:absolute;top:-10px;left:-10px;width:1px;height:1px;';
        document.body.appendChild(bait);

        await new Promise(r => setTimeout(r, 200));

        const isBlocked = bait.offsetHeight === 0 ||
          bait.offsetWidth === 0 ||
          bait.clientHeight === 0 ||
          getComputedStyle(bait).display === 'none' ||
          getComputedStyle(bait).visibility === 'hidden';

        document.body.removeChild(bait);

        if (isBlocked) {
          setAdBlockDetected(true);
          return;
        }

        // Méthode 2 : tenter de charger un script publicitaire
        try {
          const response = await fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
            method: 'HEAD',
            mode: 'no-cors',
          });
        } catch (e) {
          setAdBlockDetected(true);
        }
      } catch (e) {
        // En cas d'erreur, on ne bloque pas
      }
    };

    // Attendre un peu que la page charge
    const timer = setTimeout(detectAdBlock, 1500);
    return () => clearTimeout(timer);
  }, [user?.premium]);

  // Premium = pas de détection
  if (user?.premium) return null;

  return (
    <AnimatePresence>
      {adBlockDetected && (
        <>
          <motion.div
            className="adblock-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
          <motion.div
            className="adblock-modal"
            initial={{ opacity: 0, scale: 0.85, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.85, y: 20 }}
            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          >
            <div className="adblock-icon">🛡️</div>
            <h2 className="adblock-title">Bloqueur de publicités détecté</h2>
            <p className="adblock-text">
              Plumly est une plateforme gratuite soutenue par la publicité. Les revenus publicitaires nous permettent de rémunérer les auteurs et de maintenir la plateforme.
            </p>
            <div className="adblock-options">
              <div className="adblock-option">
                <h4>Option 1 — Désactiver ton bloqueur</h4>
                <p>Désactive ton bloqueur de publicités pour plumly.fr puis recharge la page.</p>
                <motion.button
                  className="adblock-btn-primary"
                  onClick={() => window.location.reload()}
                  whileTap={{ scale: 0.97 }}
                >
                  J'ai désactivé, recharger
                </motion.button>
              </div>
              <div className="adblock-divider">
                <span>ou</span>
              </div>
              <div className="adblock-option">
                <h4>Option 2 — Passer à Premium</h4>
                <p>Profite de Plumly sans aucune publicité pour 4,99€/mois.</p>
                <motion.button
                  className="adblock-btn-premium"
                  onClick={() => {
                    setAdBlockDetected(false);
                    window.location.href = '/profile';
                  }}
                  whileTap={{ scale: 0.97 }}
                >
                  ⭐ Devenir Premium
                </motion.button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}